import React from 'react';
import './PurchaseAddress.less';
import InputItem from 'antd-mobile/lib/input-item';
import TextareaItem from 'antd-mobile/lib/textarea-item';
import { RankDetail } from '../../../model';
import IosSelect from 'iosselect';
import 'iosselect/src/iosSelect.css';
import autobind from 'autobind-decorator';

interface PurchaseAddressPropsType {
    prefixCls?: string;
    onSaveData?: (flag: string, data: any) => void;
}

/**
 * 礼包 - 地址信息管理
 * @class PurchaseAddress
 * @extends {React.Component<PurchaseAddressPropsType, PurchaseAddressState>}
 */
class PurchaseAddress extends React.Component<PurchaseAddressPropsType, any> {
    static defaultProps = {
        prefixCls: 'purchase-address'
    };

    constructor(props, context) {
        super(props, context);
        this.state =  {
            selects: [],
            detail: '', // 详细地址
            phone: '', // 手机号
            name: '', // 名字
            isShowLoading: false, // 是否显示加载状态
        };
    }

    iosSelect: any;
    addList: any = new RankDetail({url: 'regions/v1'});;

    /* 选择地区 */
    @autobind
    Ios() {
        const {onSaveData} = this.props;
        let that = this;
        this.setState({
            isShowLoading: true
        });
        this.addList.fetch(0, function (data) {
            that.setState({
                isShowLoading: false
            });
            let selects = that.state.selects;
            that.iosSelect = new IosSelect(3,
                [data[0], data[1], data[2]],
                {
                    title: '地址选择',
                    itemHeight: 3.5,
                    headerHeight: 4.4,
                    cssUnit: 'rem',
                    relation: [1, 1],
                    showLoading: true,
                    oneLevelId: selects.length > 0 && selects[0].id,
                    twoLevelId: selects.length > 0 && selects[1].id,
                    threeLevelId: selects.length > 0 && selects[2].id,
                    callback: function (selectOneObj, selectTwoObj, selectThreeObj) {
                        selects = [
                            {value: selectOneObj.value, id: selectOneObj.id},
                            {value: selectTwoObj.value, id: selectTwoObj.id},
                            {value: selectThreeObj.value, id: selectThreeObj.id}
                        ];
                        that.setState({
                            selects: selects
                        });
                        if (onSaveData) {
                            onSaveData('select', selects)
                        }
                    }
                });
        });
    }

    @autobind
    onChangeDetail(event) {
        const {onSaveData} = this.props;
        this.setState({
            detail: event.trim()
        });
        if (onSaveData) {
            onSaveData('detail', event.trim())
        }
    }

    @autobind
    onChangePhone(event) {
        const {onSaveData} = this.props;
        this.setState({
            phone: event
        });
        if (onSaveData) {
            onSaveData('phone', event)
        }
    }

    @autobind
    onChangeName(event) {
        const {onSaveData} = this.props;
        if (event == ' ') return;
        this.setState({
            name: event
        });
        if (onSaveData) {
            onSaveData('name', event)
        }
    }

    render() {
        const {prefixCls} = this.props;
        const {selects, name, phone, detail, isShowLoading} = this.state;
        return (
            <div className={`${prefixCls}`}>
                <div className={`${prefixCls}-name-box`}>
                    <InputItem
                        maxLength={15}
                        value={name}
                        onChange={this.onChangeName}
                        placeholder="收货人姓名"
                    />
                </div>
                <div className={`${prefixCls}-name-box`}>
                    <InputItem
                        type="number"
                        placeholder="收货人手机号"
                        value={phone}
                        maxLength={11}
                        onChange={this.onChangePhone}
                    />
                </div>
                <div className={`${prefixCls}-address-box`} onClick={this.Ios}>
                    <div className={`${prefixCls}-address`}>
                        {selects.length <= 0 ? '省、市、区' : selects[0].value + '/' + selects[1].value + '/' + selects[2].value}
                    </div>
                </div>
                <div className={`${prefixCls}-textarea-box`}>
                    <TextareaItem
                        maxLength={60}
                        rows={5}
                        value={detail}
                        onChange={this.onChangeDetail}
                        placeholder="详细地址"
                    />
                </div>
                {
                    isShowLoading && (
                        <div className={`${prefixCls}-loading-box`}>
                            <div className={`${prefixCls}-loading`}/>
                        </div>
                    )
                }
            </div>
        );
    }
}

export default PurchaseAddress;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/giftComp/purchaseAddress/PurchaseAddress.tsx